<template>
    <svg viewBox="0 0 427.671 427.671">
        <path style="fill:#CF2217;" d="M386.516,335.593c0,0-2.093,30.699-30.001,30.699c-21.553,0-36.272-16.439-50.055-37.786  c39.148-34.171,64.008-85.199,64.008-142.221C370.469,83.403,289.565,0,189.765,0S9.061,83.403,9.061,186.286  s80.904,186.286,180.704,186.286c18.112,0,35.595-2.759,52.092-7.871c20.871,33.157,47.366,62.97,88.843,62.97  c84.421,0,87.91-92.077,87.91-92.077h-32.094L386.516,335.593L386.516,335.593z M189.765,341.873  c-58.185,0-105.353-69.659-105.353-155.587S131.58,30.699,189.765,30.699s105.352,69.659,105.352,155.587  c0,34.169-7.464,65.759-20.108,91.426c-14.283-20.392-31.428-37.757-55.941-43.285c-43.485-9.805-80.933,9.768-92.794,19.536  l11.163,23.024c0,0,11.285-6.488,39.267-0.008c17.631,4.083,31.332,28.551,47.034,56.623  C213.08,338.962,201.653,341.873,189.765,341.873z" />
    </svg>
</template>

<script>
export default {
    name: 'Quora'
}
</script>
